




























import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import DelayedPlanOverview from '@/componentsV2/molecules/DelayedPlanOverview/DelayedPlanOverview.vue';
import { getNeedsOnboardingCall } from '@/utils/onboardingCall';

@Component({
  components: {
    Typography,
    DelayedPlanOverview
  }
})
export default class CoinNetworkDetails extends Vue {
  @Prop() subscription!: any;

  get tPrefix() {
    return 'modals.billing.acceptance.details';
  }

  get needsOnboardingCall() {
    return getNeedsOnboardingCall();
  }
}
